import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const AnimatedBackground: React.FC = React.memo(() => {
  const lines = useMemo(() => {
    return Array.from({ length: 30 }, (_, i) => ({
      id: i,
      angle: Math.random() * 180,
      length: Math.random() * 150 + 50,
      speed: Math.random() * 15 + 10,
      delay: Math.random() * 5,
      opacity: Math.random() * 0.15 + 0.05,
      thickness: Math.random() * 2 + 1,
      isVertical: Math.random() > 0.7,
      color: Math.random() > 0.5 ? 'from-gray-300 to-gray-400' : 'from-gray-200 to-gray-300',
    }));
  }, []);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden bg-black">
      {lines.map((line) => (
        <motion.div
          key={line.id}
          className={`absolute bg-gradient-to-r ${line.color}`}
          style={{
            width: line.isVertical ? `${line.thickness}px` : `${line.length}%`,
            height: line.isVertical ? `${line.length}%` : `${line.thickness}px`,
            opacity: line.opacity,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            transform: `rotate(${line.angle}deg)`,
          }}
          animate={{
            x: line.isVertical 
              ? ['0%', `${(Math.random() > 0.5 ? 100 : -100)}%`] 
              : ['0%', `${(Math.random() > 0.5 ? 100 : -100)}%`],
            y: line.isVertical 
              ? ['0%', `${(Math.random() > 0.5 ? 100 : -100)}%`] 
              : ['0%', `${(Math.random() > 0.5 ? 50 : -50)}%`],
          }}
          transition={{
            x: {
              duration: line.speed,
              repeat: Infinity,
              repeatType: 'reverse',
              ease: "linear",
              delay: line.delay,
            },
            y: {
              duration: line.speed * 1.2,
              repeat: Infinity,
              repeatType: 'reverse',
              ease: "linear",
              delay: line.delay,
            },
          }}
        />
      ))}
    </div>
  );
});

AnimatedBackground.displayName = 'AnimatedBackground';

export default AnimatedBackground;

